function internalTarget(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u0020]/.test(value)) return null;
  try {
    const target = new URL(value, 'https://local.invalid');
    const route = decodeURIComponent(target.pathname);
    if (target.origin !== 'https://local.invalid' || route.startsWith('//') || /[\\\u0000-\u001f]/.test(route) || route.replace(/\/+$/, '').toLowerCase() === '/login') return null;
    return target.pathname + target.search + target.hash;
  } catch { return null; }
}

export function loginReturnTarget(state: unknown, returnTo: string | null): string {
  const from = (state as { from?: { pathname?: unknown; search?: unknown; hash?: unknown } } | null)?.from;
  const saved = typeof from?.pathname === 'string'
    ? from.pathname + (typeof from.search === 'string' ? from.search : '') + (typeof from.hash === 'string' ? from.hash : '')
    : null;
  return internalTarget(saved) || internalTarget(returnTo) || '/';
}
